import { useAppSelector } from '@/store/hooks';
import { getUser } from '@/store/slices/user/selectors';
import type { IWatermarkElement } from '@/types/watermarks.types';
import styles from '../watermark.module.css';

const EmailEl = (el: IWatermarkElement) => {
  const email = useAppSelector(getUser)?.email;
  return (
    <div
      style={{
        userSelect: 'none',
        fontFamily: el.settings.text?.font?.name ? `'${el.settings.text.font.name}'` : undefined,
        fontSize: el.settings.text?.font_size,
        color: (el.settings.text?.color ?? '#ffffff') + 'bf', // 75% opacity fill
        WebkitTextStroke: '1px #0000003f', // 25% opacity black stroke
      }}
      className={el.settings.duration === 'pulse' ? styles.pulse : ''}
    >
      {email}
    </div>
  );
};

export default EmailEl;
